import React from "react";
import "./speakerbio.css";
import img from '../../assets/user.png';

interface Speaker {
  name: string;
  speakerImageUrl?: string;
  company: string;
  designation: string;
  role: number;
  email: string;
  setAsSpeaker?: boolean;
  isSpeakerBio?: boolean;
}

interface SpeakerBioProps {
  speakerBio: Speaker[];
  defaultSpeakers: any[];
  isZoomSdkExpanded?: boolean
}

const SpeakerBio: React.FC<SpeakerBioProps> = ({ speakerBio, defaultSpeakers }) => {

  const defaultSpeakerEmails = defaultSpeakers.map((speaker: any) => speaker.email.toLowerCase());

  // Filter speakers based on role == 0 and exclude default speakers by email
  const filteredSpeakers = speakerBio.filter( speaker => speaker.isSpeakerBio === true);

  return (
    <div className="bio-wrapper" id='bio-speaker-view'>
      <div className="header" style={{textAlign: "center"}}>Speaker Bios</div>
      <hr />
      <div className="speakers-wrapper"
      style={{
        maxHeight: '170px',
        minHeight: '170px',
      }}
      >
        {filteredSpeakers.map((speaker, index) => (
          <div className="speaker" key={index}>
            <div className="speakaer-logo">
              <img src={speaker.speakerImageUrl ? speaker.speakerImageUrl : img} alt={speaker.name} crossOrigin='anonymous'></img>
            </div>
            <div className="info">
              <div className="name">{speaker.name}</div>
              <div className="title">{speaker.designation}</div>
              <div className="company">{speaker.company}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpeakerBio;
